import reducer from './reducers';

export { default as incidentsOperations } from './operations';
export { default as incidentsTypes } from './types';

export default reducer;
